import { useCallback, useMemo } from 'react';
import { TableDefinition } from '~/Components/DataTable/DataTable.types';
import { IMenuAction } from '~/Models/interfaces/menuAction.models';

export const useFitoListDesktop = <T extends object>({
  unstructuredList,
  items,
  keyOfId,
  tableDefinition,
}: {
  unstructuredList: T[];
  // the actions is a backward compatibility for the uncontrolled FitoList
  items: {
    id: string | number;
    onClick?: () => void;
    onSelect?: () => void;
    actions?: IMenuAction[];
  }[];
  keyOfId: keyof T;
  tableDefinition?: TableDefinition;
}) => {
  const unstructuredItems = useMemo(
    () =>
      items.map((item) => ({
        ...unstructuredList?.find(
          (i) => ((i[keyOfId] as unknown) as string).toString() === item.id.toString(),
        ),
        ...(item.actions ? { actions: item.actions } : {}),
      })),
    [unstructuredList, items, keyOfId],
  );
  const onRowClicked = useCallback(
    (instance: T) => items.find((item) => item.id === (instance[keyOfId] as any))?.onClick?.(),
    [items, keyOfId],
  );

  const onRowSelected = useCallback(
    (instance: T) => items.find((item) => item.id === (instance[keyOfId] as any))?.onSelect?.(),
    [items, keyOfId],
  );
  const desktopView = useMemo(
    () =>
      tableDefinition && {
        tableDefinition,
        items: unstructuredItems,
        onRowClicked,
        onRowSelected,
      },
    [tableDefinition, unstructuredItems, onRowClicked, onRowSelected],
  );

  return { desktopView };
};
